<template>
    <!-- <div class="max-h-[285px] overflow-auto flex flex-col rounded-md shadow-md p-4 mt-2 bg-white w-[282px] mx-auto "> -->
   <div 
    v-on-clickaway="closeDropdown"
   class="absolute  bottom-[75px] translate-y-full  right-[120px] w-[250px] bg-white rounded-lg shadow-lg z-50">
     <div class="modal-content-board">
       <!-- Close Button -->
       <woot-button
         icon="dismiss"
         class="button modal--close clear button--only-icon secondary"
         @click="$emit('close')"
       />
       <h3 class="text-[15px] mt-[8px] font-semibold">Select state</h3>
 
       <!-- Search Bar -->
       <div class="mt-4">
       <input
         type="text"
         v-model="search"
         placeholder="Search state..."
         class="search-input w-full border border-gray-300 rounded-md px-1.5 py-0.5 text-sm mb-2"
       />
       </div>
 
       <!-- Board List -->
       <div class="mt-2 max-h-32 overflow-y-auto">
         <LabelDropdownItem
           v-for="state in filteredStates"
           :key="state.id"
           :title="state.name"
           :color="state.color"
           :selected="state.id === selectedState?.id"
           :class="{ 'disabled-item': state.id === selectedState?.id }"
           :disabled="state.id === selectedState?.id"
           @click="state.id !== selectedState?.id && selectState(state)" 
         />
         <div
     v-if="noResult"
     class="text-sm text-gray-600 dark:text-white px-2 py-4 text-center"
   >
   No results found
   </div>
       </div>
       <div class="mt-1 px-2">
         <div v-if="selectedState" class="flex items-center justify-between bg-gray-100 p-2 rounded-md">
           <span class="text-sm font-medium">{{ selectedState.name }}</span>
           <!-- <button class="text-red-500 text-sm" @click="removeSelectedBoard">Cancel</button> -->
           <!-- <button @click="removeSelectedBoard" class=" cancel-cross ml-1 mb-1 text-gray-600 hover:text-black text-xl leading-none cursor-pointer px-[0.8rem]">&times;</button> -->
           <woot-button
     icon="delete"
     variant="smooth"
     size="small"
     @click="removeSelectedState"
     class="action-button black-icon"
   />
         </div>
       </div>
     </div>
   </div>
   <!-- </div> -->
 </template>
   
 <script>
 import LabelDropdownItem from 'shared/components/ui/label/LabelDropdownItem.vue';
 import { picoSearch } from '@scmmishra/pico-search';
 import { mixin as clickaway } from 'vue-clickaway';
 
 export default {
   components: { LabelDropdownItem },
   mixins: [clickaway],
   props: {
     states: {
       type: Array,
       required: true,
     },
     selectedState: {
       type: Object,
       default: null,
     },
   },
   data() {
     return {
       search: '',
     };
   },
   computed: {
    filteredStates() {
  if (!Array.isArray(this.states)) return [];

  return !this.search
    ? this.states
    : picoSearch(this.states, this.search, ['name'], { threshold: 0.9 });
},
 noResult() {
  return Array.isArray(this.filteredStates) && this.filteredStates.length === 0;
}
   },
   methods: {
     closeDropdown() {
       this.$emit('close'); // Emit the close event to the parent
     },
     selectState(state) {
       this.$emit('select', state); // Emit the selected board to the parent
       this.$emit('close'); // Close the modal after selection
     },
     removeSelectedState() {
       this.$emit('remove', this.selectedState?.id);
     },
     
   },
 };
 </script>
 
 <style scoped>
 /* .modal {
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   background-color: rgba(0, 0, 0, 0.5);
   display: flex;
   justify-content: center;
   align-items: center;
   z-index: 1000;
 } */
 
 
 
 .modal-content-board {
   background-color: #fff;
   padding: 10px;
   border-radius: 8px;
   width: 100%;
   max-width: 400px;
 }
 
 .search-bar {
   width: 100%;
   padding: 8px;
   margin-bottom: 10px;
   border: 1px solid #ccc;
   border-radius: 4px;
 }
 
 .board-list {
   max-height: 300px;
   overflow-y: auto;
   background-color: #f9f9f9; /* Change background color */
   border: 1px solid #ddd; /* Add border */
   border-radius: 4px; /* Add rounded corners */
 
 }
 label-dropdown-item {
   border: 2px solid red; /* Temporary for debugging */
 }
 
 /* label-dropdown-item {
   color: #000; 
   padding: 8px;
   color: #333; 
   background-color: #fff; 
   border-bottom: 1px solid #eee; 
 }
 
 label-dropdown-item:hover {
   background-color: #f0f0f0; 
   color: #000;
 } */
 .disabled-item {
   pointer-events: none; /* Disable interactions */
   /* opacity: 0.5;  */
 }
 .action-button {
   background: none !important;
   width: auto !important;
   color: #413f3f;
 }
 </style>